// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Aefm","productName":"Table_productName__1lCJK"};